"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TripCard: ()=>TripCard
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const brand_namespaceObject = require("@pcln/brand");
const index_js_namespaceObject = require("../../constants/index.js");
const StyledImage = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Image).withConfig({
    displayName: "TripCard__StyledImage"
})([
    "object-fit:cover;"
]);
const CustomTruncate = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Text).withConfig({
    displayName: "TripCard__CustomTruncate"
})([
    "width:100%;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;"
]);
const BackUpImage = ({ type })=>{
    let IconType;
    if ('STAY' === type) IconType = brand_namespaceObject.HotelsOutline;
    else if ('DRIVE' === type) IconType = brand_namespaceObject.CarsOutline;
    else if ('FLY' === type) IconType = brand_namespaceObject.FlightsOutline;
    else if ('PACKAGE' === type) IconType = brand_namespaceObject.PackagesOutline;
    return IconType ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Card, {
        height: "100%",
        borderRadius: "8px",
        borderWidth: 0,
        color: "primary.light",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
            width: [
                '48px',
                '88px'
            ],
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(IconType, {
                color: "primary",
                size: "32px"
            })
        })
    }) : null;
};
const TripCard = ({ trip, actualCheckStatusUrl })=>{
    let imageSrc, name, productName, brandImageUrl;
    const { type, title, dateHeader } = trip;
    name = title;
    const isPackage = type === index_js_namespaceObject.productsType.PACKAGE;
    if (isPackage) {
        const { pkgType } = trip;
        productName = pkgType;
    } else {
        const { brandImageUrl: rcBrandImageUrl, type, header, imageUrl, scheduleInfo } = trip;
        imageSrc = imageUrl || scheduleInfo?.[0]?.companyLogoUrl;
        productName = index_js_namespaceObject.products[type];
        name = name || header;
        brandImageUrl = rcBrandImageUrl;
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
        lineHeight: "16px",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Card, {
            borderRadius: 16,
            p: 2,
            mb: 2,
            width: 1,
            color: "background.lightest",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                width: 1,
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                            height: "100%",
                            width: 1,
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                                height: "100%",
                                width: 1,
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                children: type ? imageSrc ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                    width: '82px',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    children: [
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StyledImage, {
                                            src: imageSrc,
                                            width: 'STAY' === type ? '82px' : null,
                                            borderRadius: "8px",
                                            height: 'STAY' === type ? '100%' : '29px'
                                        }),
                                        brandImageUrl ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Image, {
                                            src: brandImageUrl,
                                            height: "13px"
                                        }) : null
                                    ]
                                }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(BackUpImage, {
                                    type: type
                                }) : null
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                        flexDirection: "column",
                        pl: 3,
                        children: [
                            productName && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                color: "text.light",
                                fontSize: 0,
                                mb: 1,
                                children: productName
                            }),
                            name && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomTruncate, {
                                    fontSize: 1,
                                    fontWeight: "bold",
                                    m: 0,
                                    mb: 1,
                                    children: name
                                })
                            }),
                            dateHeader && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                fontSize: 0,
                                color: "text",
                                mb: 1,
                                children: dateHeader
                            }),
                            actualCheckStatusUrl && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Link, {
                                target: "_blank",
                                href: actualCheckStatusUrl,
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                    fontSize: 0,
                                    children: "Select Trip"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
exports.TripCard = __webpack_exports__.TripCard;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TripCard"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
